
import { defineComponent, PropType } from '@vue/runtime-core'
import HospitalLabel from '@/components/elements/HospitalLabel.vue'

export default defineComponent({
  components: {
    HospitalLabel
  },

  props: {
    text: {
      type: String,
      required: true
    },
    href: {
      type: String
    },
    isOpenBlank: {
      type: Boolean,
      default: false
    },
    labels: {
      type: Array as PropType<string[]>
    },
    isShowlabels: {
      type: Boolean,
      default: false
    }
  },

  setup(props, { emit }) {
    const clickItem = (e: any) => {
      if (props.isOpenBlank || e.ctrlKey || e.metaKey) return true

      e.preventDefault()
      emit('click-item')
    }

    return {
      clickItem
    }
  }
})
